import { Tag } from "../../Tag";
import type { IFormRenderer, FormWrapperOptions, FormButtonOptions } from "./IFormRenderer";

export class DefaultFormRenderer implements IFormRenderer {

    public static toPlainObject(v: any): any {
        if (!v) { return null; }
        if (typeof v === "string") {
            try { return JSON.parse(v); } catch (e) { return null; }
        }
        if (v instanceof Map) {
            const o: any = {};
            v.forEach((val: any, key: any) => { o[key] = val instanceof Map ? DefaultFormRenderer.toPlainObject(val) : val; });
            return o;
        }
        return v;
    }

    public static stringifyValidate(v: any): string | null {
        if (!v) { return null; }
        if (typeof v === "string") { return v; }
        const plain = DefaultFormRenderer.toPlainObject(v);
        return plain ? JSON.stringify(plain) : null;
    }

    renderWrapper(opts: FormWrapperOptions, formItem: any): Tag {
        const requiredMark = opts.required ? {t: "span", class: "required-mark", txt: " *"} : null;
        const formElementTitle = opts.label ? {
            c: [
                {class: "formititle", t: "div", c: [opts.label, requiredMark]},
                {attributes: [{n: "counter", v: 1}], class: "counter", t: "div"},
            ],
            class: "formihead",
            t: "fc",
        } : null;

        const iconEl = opts.icon ? {t: "span", class: "formi-icon " + opts.icon} : null;
        const hintEl = opts.hint ? {t: "div", class: "formi-hint", txt: opts.hint} : null;

        const classes = ["formi"];
        if (opts.extraClass) { classes.push(opts.extraClass); }

        const infoAttrs: any[] = [
            {n: "name",    v: opts.name},
            {n: "n",       v: opts.name},
            {n: "max",     v: opts.max},
            {n: "t",       v: opts.label},
            {n: "info",    v: 1},
            {n: "choices", v: opts.choices},
        ];
        const validateStr = DefaultFormRenderer.stringifyValidate(opts.validate);
        if (validateStr && validateStr !== "{}") {
            infoAttrs.push({n: "validate", v: validateStr});
        }

        return new Tag({
            attributes: [
                {n: "formi", v: 1},
                {n: "id", v: opts.id},
            ],
            c: [
                {
                    c: [{
                        attributes: infoAttrs,
                        c: [{
                            c: [
                                formElementTitle,
                                {c: [iconEl, formItem], class: "tbxc", t: "div"},
                                hintEl,
                                {t: "div", class: "state"},
                            ],
                            t: "cfc",
                        }],
                        class: "textline",
                        t: "div",
                    }],
                    class: "ibox",
                    t: "div",
                },
            ],
            classes,
            t: "div",
        });
    }

    renderButton(opts: FormButtonOptions): Tag {
        const iconBox = opts.icon ? {t: "span", class: opts.icon} : undefined;
        const buttonClasses = ["buttonbox", "fc"];
        if (opts.extraClass) {
            buttonClasses.push(opts.extraClass);
        }

        return new Tag({
            attributes: [{n: "formi", v: 1}],
            c: [
                {t: "div", class: "state"},
                {
                    c: [{
                        c: [{
                            attributes: [
                                {n: "ft",     v: opts.ft},
                                {n: "formid", v: opts.formId},
                            ],
                            c: [iconBox, opts.label],
                            classes: buttonClasses,
                            t: "div",
                        }],
                        class: "b-box",
                        t: "div",
                    }],
                    class: "ibox",
                    t: "div",
                },
            ],
            classes: ["formi"],
            t: "div",
        });
    }

    renderState(wrapper: Element, state: "idle" | "loading" | "error" | "success", msg?: string): void {
        if (!wrapper) { return; }
        const stateEl = wrapper.querySelector(".state");
        if (!stateEl) { return; }
        const stateClass = state === "error"   ? "state state--error field-error"
                         : state === "success" ? "state state--success field-success"
                         : state === "loading" ? "state state--loading"
                         :                       "state state--idle";
        stateEl.className = stateClass;
        stateEl.textContent = msg || "";
        const input = wrapper.querySelector("input, textarea, select");
        if (input) {
            input.classList.toggle("is-error", state === "error");
            input.classList.toggle("is-valid", state === "success");
        }
    }
}
